import type { Vec3 } from '../../../../geo/types';
import { orientedFace, planPoint } from '../../solids';
import { roofUv } from '../masonry';
import type { StadhuisBuild } from './stadhuisParts';

/** The narrow hall ridge recedes from its gabled Dam front; the far end is hipped. */
export function buildHallRoof(s: StadhuisBuild): void {
  const h = s.plan.hall;
  const uc = (h.u0 + h.u1) / 2;
  const ridgeEnd = h.v1 - (h.u1 - h.u0) / 2;
  const p = (u: number, y: number, v: number) => planPoint(u, y, v);
  const a = p(h.u0, h.eaveY, h.v0);
  const b = p(h.u1, h.eaveY, h.v0);
  const c = p(h.u1, h.eaveY, h.v1);
  const d = p(h.u0, h.eaveY, h.v1);
  const front = p(uc, h.ridgeY, h.v0);
  const rear = p(uc, h.ridgeY, ridgeEnd);
  const slope = (points: Vec3[], outward: Vec3) => {
    orientedFace(
      s.builder,
      s.brick.roof,
      s.frame,
      points,
      outward,
      roofUv(points[0]!, points[1]!, points[2]!)
    );
  };
  slope([d, a, front, rear], [-1, 1, 0]);
  slope([b, c, rear, front], [1, 1, 0]);
  slope([c, d, rear], [0, 1, -1]);
}
